import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザのアカウント情報を取得する
 *
 * @param {Number} uid ユーザID
 * @returns {Response} レスポンスデータ
 */
export function getUserAccount (uid) {
  return request.get(`/users/${uid}/account`, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
